module.exports = __webpack_public_path__ + "img/house.2a20ea9d.svg";